import { useCallback, useState } from "react";
import {
  AndamentoCotaUsuario,
  buscarAndamentosCotaUsuarioService,
} from "../../../services/buscarAndamentosCotaUsuarioService";

export const useBuscarAndamentosCotaUsuario = () => {
  const [andamentos, setAndamentos] = useState<AndamentoCotaUsuario[]>([]);
  const [loading, setLoading] = useState(false);

  const buscar = useCallback(async (cotaUsuarioId: number) => {
    if (!cotaUsuarioId) return;

    setLoading(true);
    try {
      const dados = await buscarAndamentosCotaUsuarioService(cotaUsuarioId);
      setAndamentos(dados);
    } catch (error) {
      console.error("Erro ao buscar andamentos da cota do usuario:", error);
      setAndamentos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    andamentos,
    loading,
    buscar,
  };
};
